function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import * as log from '../../log';
import * as optimizers from './optimizers';
import { moveFacetDown } from './subtree';
export var FACET_SCALE_PREFIX = 'scale_';
export var MAX_OPTIMIZATION_RUNS = 5;
/**
 * Iterates over a dataflow graph and checks whether all links are consistent.
 */
export function checkLinks(nodes) {
  var _iterator = _createForOfIteratorHelper(nodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      var _iterator2 = _createForOfIteratorHelper(node.children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          if (child.parent !== node) {
            // log.error('Dataflow graph is inconsistent.', node, child);
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (!checkLinks(node.children)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}
/**
 * Run the specified optimizer on the provided nodes.
 *
 * @param optimizer The optimizer instance to run.
 * @param nodes A set of nodes to optimize.
 */
function runOptimizer(optimizer, nodes) {
  var modified = false;
  var _iterator3 = _createForOfIteratorHelper(nodes),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var node = _step3.value;
      modified = optimizer.optimize(node) || modified;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return modified;
}
function optimizationDataflowHelper(dataComponent, model, firstPass) {
  var roots = dataComponent.sources;
  var modified = false;
  modified = runOptimizer(new optimizers.RemoveUnnecessaryOutputNodes(), roots) || modified;
  modified = runOptimizer(new optimizers.RemoveUnnecessaryIdentifierNodes(model), roots) || modified;
  // remove source nodes that don't have any children because they also don't have output nodes
  roots = roots.filter(function (r) {
    return r.numChildren() > 0;
  });
  modified = runOptimizer(new optimizers.RemoveUnusedSubtrees(), roots) || modified;
  roots = roots.filter(function (r) {
    return r.numChildren() > 0;
  });
  if (!firstPass) {
    // Only run these optimizations after the optimizer has moved down the facet node.
    // With this change, we can be more aggressive in the optimizations.
    modified = runOptimizer(new optimizers.MoveParseUp(), roots) || modified;
    modified = runOptimizer(new optimizers.MergeBins(model), roots) || modified;
    modified = runOptimizer(new optimizers.RemoveDuplicateTimeUnits(), roots) || modified;
    modified = runOptimizer(new optimizers.MergeParse(), roots) || modified;
    modified = runOptimizer(new optimizers.MergeAggregates(), roots) || modified;
    modified = runOptimizer(new optimizers.MergeTimeUnits(), roots) || modified;
    modified = runOptimizer(new optimizers.MergeIdenticalNodes(), roots) || modified;
    modified = runOptimizer(new optimizers.MergeOutputs(), roots) || modified;
  }
  dataComponent.sources = roots;
  return modified;
}
/**
 * Optimizes the dataflow of the passed in data component.
 */
export function optimizeDataflow(data, model) {
  // check before optimizations
  checkLinks(data.sources);
  var firstPassCounter = 0;
  var secondPassCounter = 0;
  for (var i = 0; i < MAX_OPTIMIZATION_RUNS; i++) {
    if (!optimizationDataflowHelper(data, model, true)) {
      break;
    }
    firstPassCounter++;
  }
  // move facets down and make a copy of the subtree so that we can have scales at the top level
  data.sources.map(moveFacetDown);
  for (var _i = 0; _i < MAX_OPTIMIZATION_RUNS; _i++) {
    if (!optimizationDataflowHelper(data, model, false)) {
      break;
    }
    secondPassCounter++;
  }
  // check after optimizations
  checkLinks(data.sources);
  if (Math.max(firstPassCounter, secondPassCounter) === MAX_OPTIMIZATION_RUNS) {
    log.warn("Maximum optimization runs(".concat(MAX_OPTIMIZATION_RUNS, ") reached."));
  }
}